import { ValoriDefaultDocumentoDTO } from "../dto/valori-default-documentoDTO";
import { ValoriDefaultDocumentoVO } from "../vo/valori-default-documentoVO";
import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { SiNoEnum } from "../enum/si-no-enum";
import { RepertoriazioneEnum } from "../enum/repertoriazione-enum";

@Injectable({
  providedIn: "root",
})
export class MapperValoriDefaultDocumento
  implements
  MapperInterface<ValoriDefaultDocumentoDTO, ValoriDefaultDocumentoVO> {
  convertVoToDto(e: ValoriDefaultDocumentoVO): ValoriDefaultDocumentoDTO {
    throw new Error("Method not implemented.");
  }

  convertDtoToVo(dto: ValoriDefaultDocumentoDTO): ValoriDefaultDocumentoVO {
    console.log("mapper valori default doc, dto", dto);
    if (dto != null) {
      const vo = new ValoriDefaultDocumentoVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.oggetto = dto.oggetto;
      if (dto.datiComuni === SiNoEnum.SI) {
        vo.datiComuni = true;
      } else {
        vo.datiComuni = false;
      }
      if (dto.datiParticolari === SiNoEnum.SI) {
        vo.datiParticolari = true;
      } else {
        vo.datiParticolari = false;
      }
      if (dto.datiGiudiziari === SiNoEnum.SI) {
        vo.datiGiudiziari = true;
      } else {
        vo.datiGiudiziari = false;
      }

      vo.livelloConsultabilita = dto.livelloConsultabilita;

      if (dto.riservato === SiNoEnum.SI) {
        vo.riservato = true;
      } else {
        vo.riservato = false;
      }
      if (dto.daFirmare === SiNoEnum.SI) {
        vo.daFirmare = true;
      } else {
        vo.daFirmare = false;
      }
      if (dto.protocollazione === SiNoEnum.SI) {
        vo.protocollazione = true;
      } else {
        vo.protocollazione = false;
      }
      vo.repertoriazione = dto.repertoriazione;

      vo.condizioniConsultabilita = dto.condizioniConsultabilita;

      console.log("mapper valori default doc, vo", vo);
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(
    e: ValoriDefaultDocumentoVO[]
  ): ValoriDefaultDocumentoDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    t: ValoriDefaultDocumentoDTO[]
  ): ValoriDefaultDocumentoVO[] {
    throw new Error("Method not implemented.");
  }
}
